//import Swiper from 'swiper';
// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

var swiper = new Swiper ('.swiper-container', {
	loop: true,
	slidesPerView: 3,
  	spaceBetween: 10,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
  	centeredSlides : true,
	pagination: '.swiper-pagination',
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
});

var $ = require('jquery');



$(document).ready( function(){

});

//スクロールアニメ
window.onload = function() {
    loading_effect();
    scroll_effect();
    navbar_offset();
    top_img_size();

    $(window).scroll(function(){
        scroll_effect();
        navbar_offset();
    });

    $(window).resize(function(){
        top_img_size();
    });

    function loading_effect(){
		$("body").addClass("in-load");
        if((localStorage.getItem('loading') === null) || (localStorage.getItem('loading') != "1")){
            setTimeout( function(){ $('#loading_bg').fadeIn(800);},100); //0.5秒後にロゴをフェードイン!
            setTimeout( function(){ $('#loading_text').fadeIn(2000);},800); //0.8秒後にロゴをフェードイン!
            setTimeout (function(){ $('#loading').fadeOut(1000); },3500); //3.5秒後にロゴ含め真っ白背景をフェードアウト！
            localStorage.setItem('loading',"1");
        } else {
            setTimeout (function(){ $('#loading').fadeOut(500); },500); //3.5秒後にロゴ含め真っ白背景をフェードアウト！
        };
    }

    function scroll_effect(){
        $('.fadein').each(function(){
            var elemPos = $(this).offset().top;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            if (scroll > elemPos - windowHeight){
                $(this).addClass($(this).data('effect'));
                var effect = $(this).data('effect');
            }
        });
    }

    function navbar_offset(){
		var y = window.pageYOffset;

        $('#col-float-menu2').each(function(){
            var elemPos = $(this).offset().top;
            var elemPos2 = $('#col-navbar').offset().top;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            console.log(elemPos);
            console.log(scroll);
            if (scroll > elemPos2){
                $(this).addClass('scrolltop');
            } else {
                $(this).removeClass('scrolltop');
            }
        });
    }

    $('.nav-link').not('.dropdown-toggle').on('click', function () {
        $('.navbar-collapse').removeClass('show');
        $('.navbar .navbar-toggler').addClass('collapsed');
    });
    $('.dropdown-item').on('click', function () {
        $('.navbar-collapse').removeClass('show');
        $('.navbar .navbar-toggler').addClass('collapsed');
    });
    $('#menuModal .nav-link').on('click', function () {
        $('#menuModal').modal('hide');
    });

    function top_img_size(){
        $('#col-img-top img').each(function(){
            // var windowWidth2 = $(window).width();
            // var windowHeight2 = $(window).height();
            // var windowRatio2 = windowHeight2 / windowWidth2;

            var imgWidth = $(this).width();
            var imgHeight = $(this).height();
            var imgRatio = imgHeight / imgWidth;

            var boxWidth = $('#col-img-top').width();
            var boxHeight = $('#col-img-top').height();
            var boxRatio = boxHeight / boxWidth;

            var sideWidth = $('#top-side').width();
            var sideHeight = $('#top-side').height();
            var sideRatio = sideHeight / sideWidth;

             if (boxRatio > imgRatio) {
                 $(this).css({
                    width : 'auto',
                    height : '100%'
                });
            } else {
                $(this).css({
                   width : '100%',
                   height : 'auto'
               });
            };
        });
    }


    $(function() {
    var tologo = $('.col-top-message');

        //tologo.hide();
        $(this).scroll(function () {
            if ($(this).scrollTop() > 10) {
                tologo.fadeOut();
                tologo.hide();
            } else {
                tologo.fadeIn();
            }
        });
    });

    $('.btn-clear').on('click', function() {
        localStorage.removeItem('loading');
        localStorage.clear();
    });
};

$(document).ready(function(){
	autoPlayYouTubeModal();
	// Remove iframe attributes when the modal has finished being hidden from the user
	$("#exampleModalCenter").on("hidden.bs.modal", function() {
		$("#exampleModalCenter iframe").removeAttr("src allow");
		//console.log("チェック02");
	});
});

function autoPlayYouTubeModal(){
	var trigger = $("body").find('[data-toggle="modal"]');
	trigger.click(function() {
		var theModal = $(this).data( "target" ),
		videoSRC = $(this).attr( "data-theVideo" ),
		videoSRCauto = videoSRC+"?autoplay=1" ;
		$(theModal+' iframe').attr('src', videoSRCauto);
		$(theModal+' button.close').click(function () {
			$(theModal+' iframe').attr('src', videoSRC);
		});
		console.log("video");
	});
};
